export default __webpack_public_path__ + "static/media/assets-fonts.e625b92f.jpg";